module.exports = __webpack_public_path__ + "static/media/toc-mockup-3.2f58c11a.jpg";